import { GTM_ID } from '../constants/appConstants';
import { getEnv } from './env';

export function getTagManagerId(brand) {
    const env = getEnv()

    return GTM_ID[brand][env]
}